import { DetailManyToOneTable } from '@/@diffrag/form/DetailManyToOneTable'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { api } from '@/api'
import { toast } from '@/lib/toast'
import { AdminRegionListData } from 'api'

export default function Regions() {
  const { data, isFetching } = useApi({
    id: 'regionList',
    fn: api().adminRegion.adminRegionList,
  })

  const onSave = async (rows: AdminRegionListData) => {
    const names = rows.items.map((item) => item.name.trim())
    const duplicates = names.filter(
      (name, index) => names.indexOf(name) !== index,
    )

    if (duplicates.length > 0) {
      toast.error('이미 등록 된 지역입니다.')
      return
    }

    const deletedItems = data?.items.filter(
      (item) => !rows.items.some((rowItem) => rowItem.id === item.id),
    )

    if (deletedItems?.length) {
      await Promise.all(
        deletedItems.map((item) =>
          api().adminRegion.adminRegionDelete(item.id),
        ),
      )
    }

    await Promise.all(
      rows.items.map(async (row) => {
        if (row.id) {
          await api().adminRegion.adminRegionUpdate(row.id, {
            name: row.name,
            order: row.order,
          })
        } else {
          await api().adminRegion.adminRegionCreate({
            name: row.name,
            order: row.order,
          })
        }
      }),
    )

    toast.success('지역을 저장했습니다.')
  }

  return (
    <ContentDetailView
      title="지역 목록"
      data={data}
      onSave={onSave}
      hideSaveToast={() => true}
    >
      <DetailManyToOneTable
        name="items"
        title="지역 목록"
        dnd
        getFields={() => [
          {
            label: '지역명',
            key: 'name',
            type: FormFieldType.STRING,
          },
        ]}
      />
    </ContentDetailView>
  )
}
